export const formatCurrency = (amount) => {
  const num = parseFloat(amount || 0)
  const abs = Math.abs(num)
  const formatted = abs.toLocaleString('en-GH', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
  return num < 0 ? `-GHS ${formatted}` : `GHS ${formatted}`
}

export const formatCurrencyCompact = (amount) => {
  const num = parseFloat(amount || 0)
  const abs = Math.abs(num)
  let formatted
  if (abs >= 1000000) formatted = `GHS ${(abs / 1000000).toFixed(1)}M`
  else if (abs >= 1000) formatted = `GHS ${(abs / 1000).toFixed(1)}K`
  else formatted = `GHS ${abs.toFixed(2)}`
  return num < 0 ? `-${formatted}` : formatted
}

export const CURRENCY_SYMBOL = 'GHS'
export const CURRENCY_PREFIX = 'GHS '
